// @ts-check

/** @param {string} imageDataUrl */
export default async function toImageData(imageDataUrl) {
  const response = await fetch(imageDataUrl);
  const blob = response.status === 200 ? await response.blob() : null;
  const imageData = {
    source: imageDataUrl,
    file: blob,
    name: 'screenshot.png',
    type: 'image/png',
  };

  return imageData;
}
